// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"89b1c7d5","205":"f7723c20","212":"bacde980","399":"2eed2bef","453":"6d033cdb","471":"3968d0f5","615":"f6805f88","737":"03292ed7","780":"474b4534","818":"6cc276d2"}[chunkId] + ".chunk.js";
};